<ng-container *ngIf="{ isEditing: isEditing$ | async, selectedRow: selectedRow$ | async } as data">
  <apm-section-title
    *ngIf="props.label"
    [title]="props.label | apmTranslate"
    [ngClass]="{ 'mt-5': !isFirst }"
    [alignContentEnd]="false"
    matTooltip="{{ canDebug ? field.key : '' }}"
  >
    <ng-container *ngIf="props.errorsResource?.length > 0">
      <span class="ms-3"></span>
      <apm-icon
        class="me-2"
        size="sm"
        [isButton]="true"
        (iconClick)="showErrorMessages(props.errorsResource)"
        icon="i_alert_error"
      ></apm-icon>
    </ng-container>
  </apm-section-title>
  <table>
    <tr
      *ngFor="let row of field.fieldGroup"
      [ngClass]="{
        'cursor-pointer': true,
        'bg-selected-row': data.selectedRow === row.key,
        'bg-editable-row': props.editable && data.isEditing,
        'bg-certified-row--green': row.props?.flags === 1,
        'bg-certified-row--ligth-green': row.props?.flags === 3,
        'bg-certified-row--orange': row.props?.flags === 4,
      }"
      (click)="setSelectedRow($event, row.key)"
      matTooltip="{{ canDebug ? row.key : '' }}"
    >
      <td class="text bold td-label">
        <span *ngIf="row.props?.label">{{ row.props?.label | apmTranslate }}</span>
      </td>
      <td class="text-start td-uom">{{ row.props?.uom ?? '-' }}</td>
      <td class="text-start" *ngFor="let cell of row.fieldGroup" [class.error-light]="cell.props?.hasError ?? false">
        <formly-field [field]="cell"></formly-field>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center mt-3" *ngIf="props.image">
    <img src="{{ props.image }}" />
  </div>
</ng-container>
